import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  detail: { data: null, loading: false },
  thumb: { data: null, loading: false },
  statuses: { data: [], loading: false },
  blockMods: { data: [], loading: false },
  blockAxis: { data: [], loading: false },
  structTypes: { data: [], loading: false },
  locationTypes: { data: [], loading: false },
  confirm: { title: '', content: '', name: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
